export default __webpack_public_path__ + "static/screen-mockup-3069190ec9e10f9209c868e888b4d4d0.jpg";